import { useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { Form as FinalForm, FormRenderProps } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import useRouter from '../../../router/useRouter'
import { RoutePath } from '../../../router/routesConfig'
import Button from '../../../control/button/button'
import useTranslate from '../../../i18n/useTranslate'
import usePreferenceForgotPassword, { FormParam } from '../../../services/um/usePreferenceForgotPassword'
import Dialog, { DialogType } from '../../../control/dialog/dialog'
import { validateEmail } from '../../../utilities/validate'
import { spellWord } from '../../../utilities/email'

const Form = () => {
    const classes = useStyles()
    const router = useRouter()
    const t = useTranslate()
    const dialogTwoRef = useRef<Record<string, Function>>()

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const { postPreferencesForgotPassword } = usePreferenceForgotPassword()

    const formPropsRef = useRef<FormRenderProps>()

    const onFormProps = (func: FormRenderProps) => {
        formPropsRef.current = func
    }

    const validateForm = (values: FormParam) => {
        const errors: any = {}
        if (!values.email) {
            errors.email = t.get('MESSAGE.M017')
        }
        return errors
    }

    const handleClickLogin = () => {
        router.goTo(RoutePath.login)
    }

    const handleClickSubmit = async (value: FormParam) => {
        const emailValue = value?.email?.trim() ?? null
        if (emailValue && emailValue.length > 0) {
            const result = await postPreferencesForgotPassword(value.email)
            if (result.cu_net === true) {
                setConfigDialog({
                    title: t.get('ALERT.TITLE.NOTIFICATION'),
                    content: t.get('ALERT.CONTENT.USER_CUNET'),
                    type: 'alert-confirm',
                    onClickConfirm: () => handleClickLogin(),
                })
                dialogTwoRef.current?.openDialog()
                return
            } else if (result?.id) {
                setConfigDialog({
                    title: t.get('UM.FORGOTPASSWORD.FORGOT_PASS_WORD'),
                    content: t.get('MESSAGE.M018'),
                    type: 'alert-message',
                    onAfterClose: () => handleClickLogin(),
                })
                dialogTwoRef.current?.openDialog()
            } else {
                setConfigDialog({
                    title: t.get('UM.FORGOTPASSWORD.FORGOT_PASS_WORD'),
                    content: t.get('MESSAGE.M021'),
                    type: 'alert-message',
                    onAfterClose: () => handleClickLogin(),
                })
                dialogTwoRef.current?.openDialog()
            }
        }
    }

    return (
        <Grid container>
            <Grid item xs={12} className={classes.title}>
                <Typography variant="h6" className={classes.typo}>
                    {t.get('UM.FORGOTPASSWORD.FORGOT_PASS_WORD')}
                </Typography>
            </Grid>
            <FinalForm onSubmit={handleClickSubmit} validate={validateForm}>
                {(props: FormRenderProps) => {
                    onFormProps(props)
                    return (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <MyTextfield
                                    name="email"
                                    materialInputProps={{
                                        disabled: false,
                                        label: `${t.get('UM.FORGOTPASSWORD.EMAIL')}`,
                                        placeholder: `${t.get('UM.FORGOTPASSWORD.EMAIL')}`,
                                        size: 'medium',
                                    }}
                                    validates={[validateEmail(t.get('MESSAGE.M017'))]}
                                    handleValueChange={(valueEmail) => {
                                        const result = spellWord(valueEmail)
                                        props.form.change('email', result)
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container alignItems="center" style={{ justifyContent: 'space-between' }}>
                                    <Grid item style={{ float: 'left' }}>
                                        <Typography className={classes.login} onClick={handleClickLogin}>
                                            {t.get('UM.FORGOTPASSWORD.LOGIN')}
                                        </Typography>
                                    </Grid>
                                    <Grid item style={{ float: 'right' }}>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={props.handleSubmit}
                                        >
                                            {t.get('UM.FORGOTPASSWORD.OK')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </Grid>
    )
}

const useStyles = makeStyles(() => ({
    root: {
        width: '667px',
        padding: '48px',
    },
    typo: {
        fontWeight: 'bold',
    },
    login: {
        cursor: 'pointer',
        textDecoration: 'underline',
        color: '#0022FF',
    },
    title: {
        margin: '16px 0px',
    },
}))

export default Form
